import { ReactComponent as ChartSelectionIcon } from './chart-selection.svg';

export default ChartSelectionIcon;
